export function twClassWithSelector(selector: string, twClass: string): string {
  return [selector, twClass].join(':');
}

// export const bgPrimary = (selector?: string) => `${twClassWithSelector(selector, 'bg-light-bg-primary')} ${twClassWithSelector(selector, 'dark:bg-dark-bg-primary')}`;
export const bgPrimary = 'bg-light-bg-primary dark:bg-dark-bg-primary';
export const bgSecondary = 'bg-light-bg-secondary dark:bg-dark-bg-secondary';
export const bgTertiary = 'bg-light-bg-tertiary dark:bg-dark-bg-tertiary';
export const bgQuaternary = 'bg-light-bg-quaternary dark:bg-dark-bg-quaternary';
export const bgFillQuaternary
  = 'bg-light-fill-color-quaternary dark:bg-dark-fill-color-quaternary';
export const bgSeparatorNoTransparency
  = 'bg-light-separator-no-transparency dark:bg-dark-separator-no-transparency';

export const bgTransparent = 'bg-transparent dark:bg-transparent';

export const bgRed = 'bg-red-light dark:bg-red-dark';
export const bgBlue = 'bg-blue-light dark:bg-[#324f62]';
export const bgGreen = 'bg-green-light dark:bg-green-dark';
export const bgOrange = 'bg-orange-light dark:bg-orange-dark';

export const hoverBgPrimary
  = 'hover:bg-light-bg-primary dark:hover:bg-dark-bg-primary';
export const hoverBgSecondary
  = 'hover:bg-light-bg-secondary dark:hover:bg-dark-bg-secondary';
export const hoverBgTertiary
  = 'hover:bg-light-bg-tertiary dark:hover:bg-dark-bg-tertiary';
export const hoverBgQuaternary
  = 'hover:bg-light-bg-quaternary dark:hover:bg-dark-bg-quaternary';

export const hoverBgTransparent
  = 'hover:bg-transparent dark:hover:bg-transparent';
export const focusBgTransparent
  = 'focus:bg-transparent dark:focus:bg-transparent';

export const focusBgPrimary
  = 'focus:bg-light-bg-primary dark:focus:bg-dark-bg-primary';
export const focusBgTertiary
  = 'focus:bg-light-bg-tertiary dark:focus:bg-dark-bg-tertiary';
export const activeBgPrimary
  = 'active:bg-light-bg-primary dark:active:bg-dark-bg-primary';

export const textPrimary = 'text-light-primary dark:text-dark-label-primary';
export const textSecondary
  = 'text-light-label-secondary dark:text-dark-label-secondary';
export const textTertiary
  = 'text-light-label-tertiary dark:text-dark-label-tertiary';
export const textQuaternary
  = 'text-light-label-quaternary dark:text-dark-label-quaternary';

export const textRed = 'text-red-light dark:text-red-dark';
export const textBlue = 'text-blue-light dark:text-blue-secondary-dark';
export const textGreen = 'text-green-light dark:text-green-dark';

export const hoverTextPrimary
  = 'hover:text-light-primary dark:hover:text-dark-label-primary';

export const flexCenter = 'flex items-center justify-center';
export const inlineFlexCenter = 'inline-flex items-center justify-center';

export const borderPrimary
  = 'border-light-bg-primary dark:border-dark-bg-primary';
export const borderSecondary
  = 'border-light-bg-secondary dark:border-dark-bg-secondary';
export const borderLabelSecondary
  = 'border-light-bg-secondary dark:border-dark-bg-secondary';
export const borderTertiary
  = 'border-light-bg-tertiary dark:border-dark-bg-tertiary';
export const borderQuaternary
  = 'border-light-bg-quaternary dark:border-dark-bg-quaternary';
export const borderSeparatorNoTransparency
  = 'border-light-separator-no-transparency dark:border-dark-separator-transparency';

export const borderSeparatorTransparency
  = 'border-light-separator-transparency dark:border-dark-separator-transparency';

export const borderBlue = 'border-blue-light dark:border-blue-dark';
export const borderRed = 'border-red-light dark:border-red-dark';
export const focusBorderRed
  = 'focus:border-red-light dark:focus:border-red-dark';
export const activeBorderRed
  = 'active:border-red-light dark:active:border-red-dark';

export const transition200 = 'transition duration-200';

export const focusShadowButton
  = 'focus:outline-0 focus:outline-offset-0 focus:shadow-button';

export const focusRing
  = 'focus:outline-hidden focus:ring-2 focus:ring-offset-blue-light dark:focus:ring-offset-blue-dark focus:ring-opacity-50';

export const TRANSITIONS = {
  toggleable: {
    enterFromClass: 'max-h-0',
    enterActiveClass: 'overflow-hidden transition-all duration-500 ease-in-out',
    enterToClass: 'max-h-40',
    leaveFromClass: 'max-h-40',
    leaveActiveClass: 'overflow-hidden transition-all duration-500 ease-in',
    leaveToClass: 'max-h-0',
  },
  overlay: {
    enterFromClass: 'opacity-0 scale-75',
    enterActiveClass:
      'transition-transform transition-opacity duration-150 ease-in',
    leaveActiveClass: 'transition-opacity duration-150 ease-linear',
    leaveToClass: 'opacity-0',
  },
};
